import { ApiType } from "@gymflow/common";
import React, { useContext } from "react";

export const GymflowModelsContext = React.createContext<{
  api: ApiType;
}>({} as any);
const useGymflowModels = () => {
  return useContext(GymflowModelsContext);
};

export default useGymflowModels;
